import React from 'react'
import { Heading } from '@myxplor/ui'
import { FormInput } from '@myxplor/forms'
import ProviderLevelReportContainer from '../container'
import { ReportEmailAddress } from './_email'

const reportLabel = 'Provider CCS Submissions Report with Errors'

const FormFields = ({ values, errors, onChange }) => (
  <fieldset>
    <Heading small compact>
      {reportLabel}
    </Heading>

    <div className="reportForm--noHintPadding">
    <p>This report will include submissions with errors and those with changes. The date range will always show two weeks, with the selected week and the week prior.</p>
      <ReportEmailAddress
        reportLabel={reportLabel}
        value={values.email_address}
        errors={errors.email_address}
        onChange={onChange}
      />
    </div>

    <FormInput 
      name="week_start"
      label="Start Date"
      type="date"
      onChange={onChange}
      required 
      />
  </fieldset>
)

const formEndPoint = ({ gov_id }) =>
  process.env.REACT_APP_API_HOST + `/api/providers/${gov_id}/provider-reports/submissions-with-errors`

export const ProviderLevelReportSubmissionsWithErrors = ({ gov_id, resetCurrentReport }) => (
  <ProviderLevelReportContainer
    url={formEndPoint({ gov_id })}
    name={reportLabel}
    fieldsComponent={FormFields}
    resetCurrentReport={resetCurrentReport}
  />
)



// WEBPACK FOOTER //
// ./src/provider-level/reports/reports/submissions_with_errors.jsx